import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";

export default {
	name: "payslipDetail",
	components: {
		MainLayout,
		Loading,
	},

	data() {
		return {
			payslipData: {},
			details: [],
			isLoading: true,
			config: CONFIG,
			noDataMsg: CONFIG.NO_DATA_EXIST,
		};
	},

	computed: {
		hasPayslipData() {
			return !!(this.payslipData && this.payslipData.employee_name);
		},
		breadcrumbRouteName() {
			return this.$route.meta.backRoute || "payslipList";
		},
		breadcrumbLabel() {
			return this.$route.meta.breadcrumbLabel || "Payslip History";
		},
		detailTitle() {
			return this.$route.meta.title || "Payslip Detail";
		},
	},

	watch: {
		"$route.params.empPaymentId"(newId, oldId) {
			if (oldId !== undefined && newId !== oldId) {
				this.getDetail();
			}
		},
	},

	methods: {
		/**
		 * get payslip detail
		 */
		getDetail() {
			this.isLoading = true;
			this.payslipData = {};
			const basePath =
				this.$route.name === "myPayslipDetail"
					? "my/payslip"
					: "payslip";
			axios
				.get(`${basePath}/${this.$route.params.empPaymentId}/detail`)
				.then((res) => {
					const data = res.data;
					if (data && data.employee_name) {
						this.payslipData = data;
					} else {
						this.payslipData = {};
					}
					this.isLoading = false;
				})
				.catch((error) => {
					this.payslipData = {};
					this.isLoading = false;
					if (error.response && error.response.status === 401) {
						this.$store.commit("logout");
						window.location.replace("login");
					}
				});
		},

		goBack() {
			this.$router.push({ name: this.breadcrumbRouteName });
		},
	},

	mounted() {
		this.getDetail();
	},
};
